import * as React from "react";

import Box from "@mui/material/Box";

import {spacing} from "../../themes/utils";
import ScrollTop from "../../layout/ScrollTop";

const Footer: React.FC = () => {

    return (
        <Box sx={{padding: spacing(1) + " " + spacing(1),}}>
            <ScrollTop/>
        </Box>
    )
}

export default Footer;